// Action Creators
const fillCoursesList = (courseList, paginateInfo) => ({
  type: 'INSPIRE_COURSES_LIST_FILL',
  courseList,
  paginateInfo
});
export default {
  fillCoursesList,
}